//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NewsList from '~/components/other/NewsList';
import Pagination from "~/components/other/Pagination";
import Banner from '~/components/other/Banner';
import Preloader from '~/components/other/Preloader';
import NewsFilters from '~/components/news/NewsFilters';

export default {
  components: {
    NewsList,
    Pagination,
    Banner,
    Preloader,
    NewsFilters
  },
  computed: {
    currentPage() {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    pageText() {
      return this.isEn ? 'page' : 'страница'
    },
    fromText() {
      return this.isEn ? 'of' : 'из'
    }
  },
  head() {
    const seo = this.getSeo?.data?.data || {}
    const pageCount = this.news?.data?.data?.pageCount || 1
    const haveQuery = Object.keys(this.$route.query).length
    let title = seo.title
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }
    if (pageCount > 1) {
      title += ` - ${this.pageText} ${this.$route.query.pageNum || 1} ${this.fromText} ${pageCount}`
    }
    const config = {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords }
      ]
    }
    if (haveQuery) {
      config.link = [{
        rel: 'canonical',
        href: `https://my.tretyakov.ru/app/news`
      }]
    }
    return config
  },
  chimera: {
    getSeo () {
      return {
        url: `/api/v1/seo/getByCode`,
        key: `page-seo-news-${this.$i18n.locale}`,
        params: {
          code: 'news',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getBanner () {
      return {
        url: '/api/v1/banner/get/',
        key: `news-get-banner-${this.$i18n.locale}`,
        auto: true,
        params: {
          pageSize: 3,
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    news () {
      const config = {}
      // if (this.$route.query.years) {
      //   config.year = this.$route.query.years
      // }
      // if (this.$route.query.months) {
      //   config.month = this.$route.query.months
      // }
      if (this.$route.query.categories) {
        config.categoryId = this.$route.query.categories
      }
      return {
        url: '/api/v1/news/get/',
        key: `news-list-${this.$i18n.locale}`,
        auto: true,
        params: {
          pageNum: this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1,
          pageSize: 10,
          lang: this.$i18n.locale || 'ru',
          ...config
        },
        // on: {
        //   success () {
        //     setTimeout(() => {
        //       if (this.$route.query.hasOwnProperty('ignoreBanner')) {
        //         const target = this.$refs.news
        //         if (target) {
        //           window.scrollTo(0, target.offsetTop + 200);
        //         }
        //         // this.$router.push(`${this.$route.path}#news-start`)
        //       }
        //     }, 500)
        //   }
        // }
      }
    }
  }
}
